import { createFileRoute } from "@tanstack/react-router";
import { Einrichtung } from "@/pages/client/Einrichtung";

/**
 * Der Einrichtungs-Guide für Kundenkonten (13.09.2026): Schritt für Schritt
 * durch das, was wir vom Kunden brauchen. Team-Konten sehen ihn nur in der
 * Kunden-Vorschau (lesend).
 */
export const Route = createFileRoute("/_angemeldet/einrichtung")({
	component: Einrichtung,
});
